// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BpFiltersController from "./bp_filters_controller"
application.register("bp-filters", BpFiltersController)

import BpiController from "./bpi_controller"
application.register("bpi", BpiController)

import BqiController from "./bqi_controller"
application.register("bqi", BqiController)

import PbqController from "./pbq_controller"
application.register("pbq", PbqController)

import SurveyController from "./survey_controller"
application.register("survey", SurveyController)

import TextQuestionDragDropController from "./text_question_drag_drop_controller"
application.register("text-question-drag-drop", TextQuestionDragDropController)

import UppyUploadController from "./uppy_upload_controller"
application.register("uppy-upload", UppyUploadController)
